import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { userLogout } from "../../redux/reducers";
import { resetUser, logEvent, AUTH_EVENTS } from "../../utils/amplitude";

export const LogOut = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // Track logout before clearing state
    logEvent(AUTH_EVENTS.LOGOUT, {
      timestamp: new Date().toISOString(),
    });
    resetUser();
    
    // dispatch(onLogout());
    dispatch(userLogout());
    localStorage.clear();
    navigate("/");
  }, [dispatch, navigate]);
  return <></>;
};
